import { SEND_MAIL } from "../constants";
import {
  sendMailSuccess,
  setLoaderComplete,
  setLoaderStart,
  sendMailError,
} from "../actions";
import { put, takeLatest, call } from "redux-saga/effects";
import { API_URL, BASE_URL } from "../axios/config";
import axios from "../axios";

async function sendMailApi(data) {
  return axios.request({
    method: "post",
    url: BASE_URL + API_URL.MAIL_URL,
    data: data,
  });
}

function* sendMailAction(action) {
  let { payload, resolve, reject } = action;
  try {
    yield put(setLoaderStart());
    let response = yield call(sendMailApi, payload);
    yield put(setLoaderComplete());
    if (response.status === 200) {
      console.log("response.data.data", response);
      yield put(sendMailSuccess(response));
      if (resolve) resolve(response);
    } else {
      yield put(sendMailError(response));
      if (reject) reject(response);
    }
  } catch (e) {
    console.log("error =======> ", e);
    yield put(setLoaderComplete());
    yield put(sendMailError(e));
    if (reject) reject(e);
  }
}

export function* sendMailWatcher() {
  yield takeLatest(SEND_MAIL, sendMailAction);
}
